/* -------------- Operation based interfaces -------------- */

// LIST
export interface DocumentListItem {
    id?: string;
    categoryName: string;
    name: string;
    url: string;
    size: number;
    mimeType: string;
    extension: string;
    creationDate: string;
}

export interface DocumentListApiResponse {
    result: {
        items: DocumentListItem[];
    };
    error: string | null;
    isSuccessful: boolean;
}

// GET
export interface DocumentDetail {
    id: string;
    categoryName: string;
    url: string;
    name: string;
    size: number;
    mimeType: string;
    extension: string;
    creationDate: string;
}

// ADD
export interface DocumentAddData {
    categoryId: string;
    documents: File [];
}

export const defaultDocumentAddData: DocumentAddData = {
	categoryId: "",
	documents: []
};

// UPDATE
export interface DocumentUpdateData {
    documentId: string;
    documentName: string;
}

export const defaultDocumentUpdateData: DocumentUpdateData = {
	documentId: "",
	documentName: ""
};

// Page States
export type OperationStatus =
    | { type: "idle" }
    | { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
    | { type: "error"; operation: string; message: string };